import { VIDEO_STATUS_API_PATH } from 'constants/api';
import { VideoStatusInterface } from 'content/type';
import { ApiService } from 'service/api/apiService';
import { FetchResult } from 'type/apiType';

class VideoStatusService {
  constructor(private apiService: ApiService<VideoStatusInterface>) {}

  public async fetch(params?: URLSearchParams): Promise<FetchResult<VideoStatusInterface>> {
    const videoStatus = await this.apiService.fetch(params);
    return videoStatus;
  }

  // public async fetchById(id: number): Promise<VideoStatusInterface> {
  //   const videoStatus = await this.apiService.fetchById(id);
  //   return videoStatus;
  // }
}

export const videoStatusService = new VideoStatusService(
  new ApiService<VideoStatusInterface>(VIDEO_STATUS_API_PATH)
);
